import React, { useState, useEffect } from "react";

import TagsSelectCard from "components/Tags/TagsSelectCard";
import ValuesSelectCard from "components/Values/ValuesSelectCard";

import FormData from "./help/FormData";

import { getTagsListSettings } from "services/tags";

import { useSettings } from 'utils/settings';

const Form = ({
    itemToEdit = null,
    onFormSubmit,
    onCancelHandler
}) => {
    const [settings, setSettings] = useSettings();
    const [activeSection, setActiveSection] = useState('form');

    const [form, setForm] = useState({
        uid: null,
        title: "",
        tags: [],
        values: []
    });

    useEffect(() => {
        if (itemToEdit) {
            setForm({
                uid: itemToEdit.uid,
                title: itemToEdit.title,
                tags: itemToEdit.tags,
                values: itemToEdit.values
            });
        }
    }, [itemToEdit]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prevForm => ({
            ...prevForm,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

     const handleRemoveItem = (itemType, uid) => {
        switch (itemType) {
            case 'values':
                setForm(prev => ({
                    ...prev,
                    values: prev.values.filter(item => item.uid !== uid)
                }));
                break;
            case 'tag':
                setForm(prev => ({
                    ...prev,
                    tags: prev.tags.filter(item => item.uid !== uid)
                }));
                break;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await onFormSubmit({
                ...form,
                values: form.values.map(item => item.uid),
                tags: form.tags.map(item => item.uid),
            });
        } catch (error) {
            console.error('Failed to save group:', error);
        }
    };

    const handleCancel = () => {
        setForm({
            uid: null,
            title: "",
            tags: [],
            values: []
        });

        onCancelHandler();
    };

    const handleAddValue = (item) => {
        setForm(prev => ({
            ...prev,
            values: [...prev.values, item]
        }));

        setActiveSection('form');
    };

    const handleSaveSelectedItem = (itemType, selectedItems) => {
        switch (itemType) {
            case 'values':
                setForm(prev => ({
                    ...prev,
                    values: selectedItems
                }));
                break;
            case 'tag':
                setForm(prev => ({
                    ...prev,
                    tags: selectedItems
                }));
                break;
        }

        setActiveSection('form');
    };

    function settingChangeHandler(section, settingId) {
        setSettings(prev => {
            const currentValue = prev['tags'][settingId];
            const value = settingId === 'sort'
                ? (currentValue === 'asc' ? 'desc' : 'asc')
                : !currentValue;

            return {
                ...prev,
                ['tags']: {
                    ...prev['tags'],
                    [settingId]: value
                }
            };
        });
    }

    const renderContent = () => {
        switch (activeSection) {
            case "values":
                return <ValuesSelectCard 
                    onClick={handleAddValue}
                    onCancel={() => setActiveSection('form')}
                />;
            case "tags":

                const tagsListSettings = {
                    'section': 'tags',
                    'items': {
                        'displayGroups': {
                            'label': 'Display groups',
                            'type': 'switch',
                            'checked': settings.tags.displayGroups
                        },
                    }
                };

                return <TagsSelectCard 
                    selectedItems={form.tags}
                    settings={tagsListSettings}
                    onSettingChange={settingChangeHandler}
                    onSave={handleSaveSelectedItem}
                    onCancel={() => setActiveSection('form')}
                />;
            case "form":
            default:
                return <FormData
                    form={form}
                    onInputChange={handleInputChange}
                    onItemRemove={handleRemoveItem}
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                    setActiveSection={setActiveSection}
                    setForm={setForm}
                />;
        }
    };

    return (
       renderContent()
    );
};

export default Form;
